import { render, staticRenderFns } from "./DetailIndex.vue?vue&type=template&id=911c33b8&scoped=true"
import script from "./DetailIndex.vue?vue&type=script&lang=js"
export * from "./DetailIndex.vue?vue&type=script&lang=js"
import style0 from "./DetailIndex.vue?vue&type=style&index=0&id=911c33b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911c33b8",
  null
  
)

export default component.exports